import { SvgIcon, SvgIconProps } from '@mui/material';

export function FamilyTreeAncestryIcon(props: SvgIconProps) {
  const { color } = props;

  return (
    <SvgIcon {...props}>
      <g clip-path="url(#clip0_1966_45763)">
        <path
          d="M11.3235 10.8458C12.2997 9.87429 12.1721 8.17244 12.1721 8.17244C12.1721 8.17244 10.4622 8.0455 9.48604 9.01702C8.50989 9.98854 8.63743 11.6904 8.63743 11.6904C8.63743 11.6904 10.3474 11.8173 11.3235 10.8458Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M2.69125 19.4371C3.6674 18.4656 3.53986 16.7637 3.53986 16.7637C3.53986 16.7637 1.8299 16.6368 0.853747 17.6083C-0.121551 18.5807 0.00514423 20.2817 0.00514423 20.2817C0.00514423 20.2817 1.7151 20.4086 2.69125 19.4371Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M2.35281 15.8405C3.7201 16.0283 5.00661 14.9003 5.00661 14.9003C5.00661 14.9003 4.07553 13.4675 2.70824 13.2797C1.34095 13.0918 0.0544434 14.2199 0.0544434 14.2199C0.0544434 14.2199 0.985526 15.6526 2.35281 15.8405Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M7.70971 10.509C7.89847 11.8698 6.76502 13.1502 6.76502 13.1502C6.76502 13.1502 5.32545 12.2235 5.13669 10.8627C4.94792 9.5019 6.08137 8.2215 6.08137 8.2215C6.08137 8.2215 7.52094 9.14816 7.70971 10.509Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M9.91112 12.6416C8.54383 12.4537 7.25732 13.5818 7.25732 13.5818C7.25732 13.5818 8.18841 15.0145 9.5557 15.2024C10.923 15.3903 12.2095 14.2622 12.2095 14.2622C12.2095 14.2622 11.2784 12.8295 9.91112 12.6416Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M4.55429 17.9723C4.36552 16.6115 5.49898 15.3311 5.49898 15.3311C5.49898 15.3311 6.93854 16.2577 7.12731 17.6185C7.31608 18.9793 6.18262 20.2597 6.18262 20.2597C6.18262 20.2597 4.74306 19.3331 4.55429 17.9723Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M13.4187 22.6927L14.5956 21.5215C10.4826 18.2616 5.09937 13.2416 5.09937 13.2416C5.09937 13.2416 10.1434 18.6002 13.4187 22.6927Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M11.9748 19.9009V20.5017C10.0803 20.2885 7.40698 20.2013 7.40698 20.2013C7.40698 20.2013 10.0812 20.115 11.9748 19.9009Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M26.1783 12.1347C25.2021 13.1062 23.4922 12.9793 23.4922 12.9793C23.4922 12.9793 23.3646 11.2774 24.3408 10.3059C25.3169 9.33438 27.0269 9.46132 27.0269 9.46132C27.0269 9.46132 27.1544 11.1632 26.1783 12.1347Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M17.0052 10.8458C16.0291 9.87429 16.1566 8.17244 16.1566 8.17244C16.1566 8.17244 17.8666 8.0455 18.8427 9.01702C19.8189 9.98854 19.6913 11.6904 19.6913 11.6904C19.6913 11.6904 17.9814 11.8173 17.0052 10.8458Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M25.6367 19.4371C24.6605 18.4656 24.7881 16.7637 24.7881 16.7637C24.7881 16.7637 26.498 16.6368 27.4742 17.6083C28.4503 18.5798 28.3228 20.2817 28.3228 20.2817C28.3228 20.2817 26.6128 20.4086 25.6367 19.4371Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M25.9751 15.8405C24.6078 16.0283 23.3213 14.9003 23.3213 14.9003C23.3213 14.9003 24.2524 13.4675 25.6197 13.2797C26.9869 13.0918 28.2735 14.2199 28.2735 14.2199C28.2735 14.2199 27.3424 15.6526 25.9751 15.8405Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M20.6181 10.509C20.4294 11.8698 21.5628 13.1502 21.5628 13.1502C21.5628 13.1502 23.0024 12.2235 23.1912 10.8627C23.3799 9.5019 22.2465 8.2215 22.2465 8.2215C22.2465 8.2215 20.8069 9.14816 20.6181 10.509Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M18.4168 12.6416C19.7841 12.4537 21.0706 13.5818 21.0706 13.5818C21.0706 13.5818 20.1395 15.0145 18.7722 15.2024C17.4049 15.3903 16.1184 14.2622 16.1184 14.2622C16.1184 14.2622 17.0495 12.8295 18.4168 12.6416Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M23.7737 17.9723C23.9624 16.6115 22.829 15.3311 22.829 15.3311C22.829 15.3311 21.3894 16.2577 21.2007 17.6185C21.0119 18.9793 22.1453 20.2597 22.1453 20.2597C22.1453 20.2597 23.5849 19.3331 23.7737 17.9723Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M14.9101 22.6927L13.7333 21.5215C17.8462 18.2616 23.2295 13.2416 23.2295 13.2416C23.2295 13.2416 18.1855 18.6002 14.9101 22.6927Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M16.353 19.9009V20.5017C18.2475 20.2885 20.9209 20.2013 20.9209 20.2013C20.9209 20.2013 18.2467 20.115 16.353 19.9009Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M17.3896 32H10.9384C13.2971 32 14.1644 5.49738 14.1644 5.49738C14.1644 5.49738 15.0317 32 17.3896 32Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M12.8651 2.48719C12.8651 3.86068 14.1635 4.97437 14.1635 4.97437C14.1635 4.97437 15.4619 3.86068 15.4619 2.48719C15.4619 1.11369 14.1635 0 14.1635 0C14.1635 0 12.8651 1.11369 12.8651 2.48719Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M10.3763 5.96284C11.2096 7.05791 12.9204 7.16539 12.9204 7.16539C12.9204 7.16539 13.2801 5.49739 12.4468 4.40232C11.6135 3.30724 9.90265 3.19977 9.90265 3.19977C9.90265 3.19977 9.54297 4.86777 10.3763 5.96284Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M17.9516 5.96284C17.1183 7.05791 15.4075 7.16539 15.4075 7.16539C15.4075 7.16539 15.0479 5.49739 15.8811 4.40232C16.7144 3.30724 18.4253 3.19977 18.4253 3.19977C18.4253 3.19977 18.7849 4.86777 17.9516 5.96284Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M22.0127 6.94282C21.1794 8.03789 19.4686 8.14537 19.4686 8.14537C19.4686 8.14537 19.1089 6.47737 19.9422 5.3823C20.7755 4.28722 22.4863 4.17975 22.4863 4.17975C22.4863 4.17975 22.846 5.84775 22.0127 6.94282Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M26.4292 7.22883C25.5959 8.3239 23.8851 8.43138 23.8851 8.43138C23.8851 8.43138 23.5254 6.76338 24.3587 5.66831C25.192 4.57324 26.9028 4.46576 26.9028 4.46576C26.9028 4.46576 27.2625 6.13376 26.4292 7.22883Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M6.34245 6.94282C7.17575 8.03789 8.88656 8.14537 8.88656 8.14537C8.88656 8.14537 9.24624 6.47737 8.41294 5.3823C7.57964 4.28722 5.86883 4.17975 5.86883 4.17975C5.86883 4.17975 5.50915 5.84775 6.34245 6.94282Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M1.9268 7.22883C2.7601 8.3239 4.47091 8.43138 4.47091 8.43138C4.47091 8.43138 4.83059 6.76338 3.99729 5.66831C3.16399 4.57324 1.45318 4.46576 1.45318 4.46576C1.45318 4.46576 1.0935 6.13376 1.9268 7.22883Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M22.0127 22.3686C21.1794 21.2735 19.4686 21.166 19.4686 21.166C19.4686 21.166 19.1089 22.834 19.9422 23.9291C20.7755 25.0242 22.4863 25.1316 22.4863 25.1316C22.4863 25.1316 22.846 23.4636 22.0127 22.3686Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M26.4292 22.0817C25.5959 20.9866 23.8851 20.8792 23.8851 20.8792C23.8851 20.8792 23.5254 22.5471 24.3587 23.6422C25.192 24.7373 26.9028 24.8448 26.9028 24.8448C26.9028 24.8448 27.2625 23.1768 26.4292 22.0817Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M6.34245 22.3686C7.17575 21.2735 8.88656 21.166 8.88656 21.166C8.88656 21.166 9.24624 22.834 8.41294 23.9291C7.57964 25.0242 5.86883 25.1316 5.86883 25.1316C5.86883 25.1316 5.50915 23.4636 6.34245 22.3686Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M1.9268 22.0817C2.7601 20.9866 4.47091 20.8792 4.47091 20.8792C4.47091 20.8792 4.83059 22.5471 3.99729 23.6422C3.16399 24.7373 1.45318 24.8448 1.45318 24.8448C1.45318 24.8448 1.0935 23.1768 1.9268 22.0817Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M11.3235 18.7102C12.2997 17.7387 12.1721 16.0368 12.1721 16.0368C12.1721 16.0368 10.4622 15.9099 9.48604 16.8814C8.50989 17.8529 8.63743 19.5548 8.63743 19.5548C8.63743 19.5548 10.3474 19.6817 11.3235 18.7102Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M17.0052 18.7102C16.0291 17.7387 16.1566 16.0368 16.1566 16.0368C16.1566 16.0368 17.8666 15.9099 18.8427 16.8814C19.8189 17.8529 19.6913 19.5548 19.6913 19.5548C19.6913 19.5548 17.9814 19.6817 17.0052 18.7102Z"
          fill={color || '#4A3B8F'}
        />
      </g>
    </SvgIcon>
  );
}
